import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Historique from "./pages/Historique";
import Association from "./pages/Association";
import PrincipesPedagogiques from "./pages/PrincipesPedagogiques";
import Charte from "./pages/Charte";
import AgencementInterieur from "./pages/AgencementInterieur";
import QuellePedagogie from "./pages/QuellePedagogie";
import QuelsOutils from "./pages/QuelsOutils";
import ActivitesClasses from "./pages/ActivitesClasses";
import ActivitesEcole from "./pages/ActivitesEcole";
import Informations from "./pages/Informations";
import Articles from "./pages/Articles";
import Liens from "./pages/Liens";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Navbar />
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/historique" element={<Historique />} />
            <Route path="/association" element={<Association />} />
            <Route path="/principes-pedagogiques" element={<PrincipesPedagogiques />} />
            <Route path="/charte" element={<Charte />} />
            <Route path="/agencement-interieur" element={<AgencementInterieur />} />
            <Route path="/quelle-pedagogie" element={<QuellePedagogie />} />
            <Route path="/quels-outils" element={<QuelsOutils />} />
            <Route path="/activites-des-classes" element={<ActivitesClasses />} />
            <Route path="/activites-ecole" element={<ActivitesEcole />} />
            <Route path="/informations" element={<Informations />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/liens" element={<Liens />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </div>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;